import { createContext } from "react";
import type { Status } from "types/Status";

const AthleteStatusContext = createContext<Status | undefined>(undefined);
AthleteStatusContext.displayName = "AthleteStatusContext";

export default AthleteStatusContext;
